import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import StockAgeDistributionChart from "./StockAgeDistributionChart";

// Static data for stock age distribution
const STATIC_STOCK_AGE_DATA = {
  ageRanges: ["0-5 Days", "6-10 Days", "11-15 Days", "16-20 Days", "21+ Days"],
  components: {
    "PRBC": [120, 95, 80, 55, 30],
    "FFP": [85, 70, 60, 45, 25],
    "Platelets": [65, 50, 40, 28, 15],
  },
};

const StockAgeDistributionWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Stock Age Distribution")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <StockAgeDistributionChart data={STATIC_STOCK_AGE_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default StockAgeDistributionWrapper;
